import { IMetaTag } from '@types';
import { AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useQuery } from '@tanstack/react-query';

async function getMetaTagAutocomplete(searchKeyword: string | null): Promise<AxiosResponse<FetchResult<IMetaTag[]>>> {
  const response = await instance.get(`/meta-tags/autocomplete?searchKeyword=${searchKeyword}`);
  return response;
}

const useFetchMetaTagAutocomplete = (searchKeyword: string | null) => {
  const { data: originalData, error } = useQuery({
    queryKey: ['get', `/meta-tags/autocomplete?searchKeyword=${searchKeyword}`],
    queryFn: () => getMetaTagAutocomplete(searchKeyword),
    retry: false,
    refetchOnWindowFocus: false,
    enabled: Boolean(searchKeyword)
  });

  const data = originalData?.data.data;

  return { data, error };
};

export default useFetchMetaTagAutocomplete;
